import * as React from 'react';

import {useCustomFieldHandlers} from '../../../core-entity/hooks/use-custom-field-handlers';
import type {UpdateCustomField} from '../../../core-entity/hooks/use-custom-field-handlers';

import {useUpdateContactCustomFieldValue} from '../graphql/hooks/use-update-contact-custom-field-value';

export function useContactCustomFieldHandlers(contactId: string) {
    const {updateContactCustomFieldValue} = useUpdateContactCustomFieldValue();

    const updateCustomField = React.useCallback<UpdateCustomField>(
        ({fieldName, value}) =>
            updateContactCustomFieldValue({
                id: contactId,
                customFields: [
                    {
                        fieldName,
                        value,
                    },
                ],
            }),
        [contactId, updateContactCustomFieldValue]
    );

    return useCustomFieldHandlers(updateCustomField);
}
